import _ from 'lodash';
export const genConvertProp = (data, map) => {
    const tmpData = data;
    for (const key in map) {
        if (typeof map[key] === 'function') {
            tmpData[key] = map[key](tmpData);
        } else tmpData[key] = tmpData[map[key]];
    }
    return tmpData;
};

export const getPath = (item, obj, map, r = []) => {
    const id = item[map.id || map.key],
        parentId = item[map.parent_id || map.parentId || map.parent_id];
    if (id) r.unshift(id);
    if (obj[parentId]) getPath(obj[parentId], obj, map, r);
    return r;
};

export const getPathName = (item, obj, map, r = []) => {
    const name = item[map.name || map.title || map.text],
        parentId = item[map.parent_id || map.parentId || map.parent_id];
    if (name && item.children) {
        r.unshift(name);
    }
    if (obj[parentId]) getPathName(obj[parentId], obj, map, r);
    return r;
};

export const setAttr = (item, map, obj) => {
    item['text'] = item[map.name || map.title];
    item['depth'] = 0;
    item['pathName'] = getPathName(item, obj, map).join('/');
    item['path'] = getPath(item, obj, map).join('/');
    item['depth'] = item['path'] ? item['path'].split('/').length - 1 : 0;
};
export const convertTree = (data, convertType) => {
    const tmpObj = {},
        result = [];
    if (!data) return result;

    let idProperty, keyProperty, parentIdProperty, childrenProperty, cloneData, length;
    idProperty = convertType.id;
    keyProperty = convertType.key || idProperty;
    parentIdProperty = convertType.parent_id;
    childrenProperty = convertType.children;
    cloneData = _.cloneDeep(data);
    length = cloneData.length;
    for (let i = 0, len = length; i < len; i++) {
        const item = cloneData[i];
        item['path'] = item[parentIdProperty];
        item['pathName'] = item['text'];
        tmpObj[item[keyProperty]] = item;
    }
    for (let i = 0, len = length; i < len; i++) {
        const item = cloneData[i],
            parent = tmpObj[item[parentIdProperty]];
        if (parent) {
            parent[childrenProperty] = parent[childrenProperty] ? parent[childrenProperty] : [];
            setAttr(item, convertType, tmpObj);
            const resultChild = genConvertProp(item, convertType);
            parent[childrenProperty].push(resultChild);
        } else {
            setAttr(item, convertType, tmpObj);
            const resultChild = genConvertProp(item, convertType);
            result.push(resultChild);
        }
    }
    return result;
};
